// @ts-strict-ignore
import React from 'react';
import type { FieldValues, UseFormRegister } from 'react-hook-form';
import snakeCase from 'lodash/snakeCase';
import {
  Checkbox,
  TextField,
  Label,
  Box,
  Select,
} from '@usealloy/component-library';

import type { InputValues } from './types';

type InputFieldsProps = {
  errors: object;
  inputs: Array<InputValues>;
  register: UseFormRegister<FieldValues>;
  setValue: (name, value) => void;
};

const InputFields = ({
  errors,
  inputs,
  register,
  setValue,
}: InputFieldsProps) => (
  <>
    {inputs.map(input => {
      const { type } = input;
      if (type === 'select') {
        return (
          <Box key={input.label} direction="column" alignItems="flex-start">
            <Label htmlFor={input.name || snakeCase(input.label)}>
              {input.label}
            </Label>
            <Select
              options={input.options}
              name={input.name}
              key={input.label}
              disabled={input.disabled}
              style={input.style}
              placeholder={input.placeholder}
              data-testid={input.name || snakeCase(input.label)}
              {...register(input.name || snakeCase(input.label), { required: input.required })}
            />
          </Box>
        );
      }

      if (type === 'text') {
        return (
          <Box key={input.label} direction="column" alignItems="flex-start">
            <Label htmlFor={input.name || snakeCase(input.label)}>
              {input.label}
            </Label>
            <TextField
              id={input.name || snakeCase(input.label)}
              style={input.style}
              error={errors[input.name] ? input.error : false}
              key={input.label}
              optional={input.optional}
              placeholder={input.placeholder}
              type={input.textType}
              disabled={input.disabled}
              data-testid={input.name || snakeCase(input.label)}
              {...register(
                input.name || snakeCase(input.label),
                {
                  required: input.required,
                  pattern: input.pattern,
                },
              )}
            />
          </Box>
        );
      }

      if (type === 'checkbox') {
        // pattern was causing a TS failure, and isn't needed for checkboxes
        const { pattern, ...restInput } = input;
        const { onChange, ...rest } = register(input.name || snakeCase(input.label));
        return (
          <Checkbox
            key={input.label}
            {...restInput}
            label={input.label}
            onChange={event => {
              setValue(input.name, event.target.checked);
              onChange(event);
            }}
            data-testid={input.name || snakeCase(input.label)}
            {...rest}
          />
        );
      }
      return null;
    })}
  </>
);

export default InputFields;
